import React from "react";
import CartProvider from "./src/context/CartProvider";
import ShopifyProvider from "./src/context/ShopifyProvider";
import "./src/styles/tailwind.css";
import Layout from "./src/components/layout";

window.onload = function () {
  // ============= STAGGER =============
  function staggerEntry(entries, index) {
    entries.forEach(function (entry, index) {
      if (entry.isIntersecting === true) {
        setTimeout(function () {
          entry.target.classList.add("is-showing");
        }, 150 * (index + 1));
      }
    });
  }
  var staggerOptions = {};
  var staggerObserver = new IntersectionObserver(staggerEntry, staggerOptions);
  var staggerItems = document.querySelectorAll(".stagger-item");

  staggerItems.forEach(function (item, index) {
    staggerObserver.observe(item);
  });

  // ============= FADE =============
  function fadeEntry(entries, index) {
    entries.forEach(function (entry, index) {
      if (entry.isIntersecting === true) {
        entry.target.classList.add("is-showing");
      }
    });
  }

  var fadeOptions = {};
  var fadeObserver = new IntersectionObserver(fadeEntry, fadeOptions);
  var fadeItems = document.querySelectorAll(".fade-item");

  fadeItems.forEach(function (item, index) {
    fadeObserver.observe(item);
  });
};

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 * 
 * Polyfill for lazy loading which Safari doesn't support currently
 */

 export const onClientEntry = async () => {
  if (typeof IntersectionObserver === "undefined") {
    await import("intersection-observer")
  }
}

export function wrapPageElement({ element, props }) {
  var newsletterType = props.location.pathname.indexOf("tick-pro") === -1 ? "default" : "tick pro"
  var pageClassName = props.location.pathname ? props.location.pathname.replaceAll("/", "-").slice(1) : 'page'
  return <Layout {...props} pageClassName={pageClassName} newsletterType={newsletterType}>{element}</Layout>;
}

export function wrapRootElement({ element }) {
  return (
    <ShopifyProvider>
      <CartProvider>{element}</CartProvider>
    </ShopifyProvider>
  );
}
